<!-- Global Loader for Initial Page Load -->
<div class="template-ai-container">
    <!-- Common Filter Component -->
    <app-generic-common-filter [config]="filterConfig" [error]="error"
      [preselectedBrand]="preselectedBrand" [preselectedBrandDomain]="projectData?.description || null" [initialCountry]="country"
      [projectId]="projectId" [projectName]="projectData?.name || null"
      [currentVersionName]="currentVersionName" [currentProjectDataId]="projectdataId"
      [initialSelectedEntities]="selectedEntities"
      (filterChange)="onFilterChange($event)"
      (analyzeClick)="onAnalyzeClick($event)">
    </app-generic-common-filter>

    <!-- Results Section -->
    @if(table && table.length > 0){
    <div class="results-section">
      <h3>Analysis Results</h3>
      <p>Found {{ table.length }} brands for analysis</p>
      <!-- Add your results display here -->
    </div>
    }

    <!-- Common Tabs Component (loader shown under tabs when history is loading) -->
    <app-generic-common-tabs [config]="tabsConfig" [selectedEntities]="selectedEntities"
      [category]="category" [country]="country"
      [historyLoading]="isHistoryLoading"
      (tabChange)="onTabChange($event)" (reloadTab)="onReloadTab($event)"
      (visualizationChange)="onVisualizationChange($event)">
    </app-generic-common-tabs>
  </div>
